import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'
import Vue from 'vue'

const vueInstance = new Vue()

const { jwt } = useJwt(axios, {}, vueInstance)
export default jwt
